import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { FlatButton } from '../../../../components/button/FlatButton';
import { DialogHeader } from '../../../../components/dialog/DialogHeader';
import { DialogTrigger } from '../../../../components/dialog/DialogTrigger';
import { DateInput } from '../../../../components/form-elements/DateInput';
import { RollFormingPaperworkDocument } from '../../../../models/production/rollforming-paperwork-document';

export const RollFormingPaperwork = () => {
    
    const [isOpen, setIsOpen] = React.useState(false);
    const [startDate, setStartDate] = React.useState(new Date());
    const [endDate, setEndDate] = React.useState(new Date());
    const [overridesFile, setOverridesFile] = React.useState<any>();
    const dispatch = useDispatch();

    /**
     * Handle the dialog open click
     */
    const onOpenClick = () => {
        setIsOpen(true);
    };

    /**
     * Handle the diaog close click
     */
    const onCloseClick = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setIsOpen(false);
    };

    /**
     * Handler for changing the start date.
     * @param newDate The new start date as chosen 
     */
    const onStartDateChange = (newDate: Date) => {
        setStartDate(newDate);
    };

    /**
     * Handler for changing the end date.
     * @param newDate The new end date as chosen 
     */
    const onEndDateChange = (newDate: Date) => {
        setEndDate(newDate);
    };

    const setFile = (evt: any) => {
        setOverridesFile(evt.target.files[0]);
    };

    /**
     * Format the dates and initiate the AccountMate report command
     */
    const runReport = () => {
        if (startDate && endDate) {
            const req = new RollFormingPaperworkDocument(startDate, endDate, overridesFile);
            dispatch(getDocumentHelper(req));
            onCloseClick();
        }
    };

    return (
        <React.Fragment>
            <div className="report-card-wrap blue">
                <div className="row">
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <h3>Roll Forming Paperwork</h3>
                                <p>Obtain roll forming paperwork for the specified date cutoff date.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <DialogTrigger
                                    onClick={onOpenClick}
                                    text="Run Report" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Dialog
                open={isOpen}
                className="report-dialog"
                onClose={onCloseClick}
                maxWidth="md"
                aria-labelledby="form-dialog-title">

                <DialogHeader>
                    <h1>Roll Forming Paperwork</h1>
                </DialogHeader>

                <DialogContent>
                    <div className="row">
                        <div className="col">
                            <p>Provide a cutoff date and an overrides file if desired.</p>
                        </div>
                    </div>
                    <div className="row justify-content-around">
                        <div className="col-auto">
                            <DateInput
                                id="endDate"
                                label="Start Date"
                                value={startDate}
                                onChange={onStartDateChange}
                                inline={true}
                            />
                        </div>
                        <div className="col-auto">
                            <DateInput
                                id="endDate"
                                label="End Date"
                                value={endDate}
                                onChange={onEndDateChange}
                                inline={true}
                            />
                        </div>
                        <div className="col">
                            <input
                                id="overrides-import"
                                accept=".xls, .xlsx"
                                type="file"
                                name="file"
                                onChange={setFile} />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <FlatButton
                        id="rollformingNoBtn"
                        text="Cancel"
                        classes="negative"
                        onBtnClick={onCloseClick} />
                    <FlatButton
                        id="rollformingYesBtn"
                        text="Go"
                        classes="positive"
                        onBtnClick={runReport} />
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );

};
